import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { createReducer /* , nanoid*/ } from '@reduxjs/toolkit'

import {
  updateBlockNumber,
  updateChainId,
  // addPopup,
  // ApplicationModal,
  // PopupContent,
  // removePopup,
  // setKashiApprovalPending,
  // setModal,
  updateConnect,
  updateLanguage,
  updateTheme,
} from './actions'

// type PopupList = Array<{
//   key: string
//   show: boolean
//   content: PopupContent
//   removeAfterMs: number | null
// }>

export type Theme = 'light' | 'dark' | 'dank'
export interface WithApplicationState {
  [path: string]: ApplicationState
}
export interface ApplicationState {
  readonly blockNumber: { readonly [chainId: number]: number }
  chainId: ChainId // the user's choice for dark mode or light mode
  theme: Theme
  language: string
  connected: boolean
  // readonly popupList: PopupList
  // readonly modal: ApplicationModal | null
  // kashiApprovalPending: string
}

const initialState: ApplicationState = {
  blockNumber: {},
  chainId: ChainId.SMARTBCH,
  theme: 'light',
  language: 'en',
  connected: false,
  // popupList: [],
  // modal: null,
  // kashiApprovalPending: '',
}

export default createReducer(
  initialState,
  (builder) =>
    builder
      .addCase(updateBlockNumber, (state, action) => {
        const { chainId, blockNumber } = action.payload
        if (typeof state.blockNumber[chainId] !== 'number') {
          state.blockNumber[chainId] = blockNumber
        } else {
          state.blockNumber[chainId] = Math.max(blockNumber, state.blockNumber[chainId])
        }
      })
      .addCase(updateChainId, (state, action) => {
        state.chainId = action.payload.chainId
        // state.timestamp = currentTimestamp()
      })
      .addCase(updateTheme, (state, action) => {
        const { theme } = action.payload
        if (state.theme !== theme) {
          state.theme = theme
        }
      })
      .addCase(updateLanguage, (state, action) => {
        const { language } = action.payload
        if (state.language !== language) {
          state.language = language
        }
      })
      .addCase(updateConnect, (state, action) => {
        const { connect } = action.payload
        state.connected = connect
      })
  //  .addCase(setModal, (state, action) => {
  //    state.modal = action.payload
  //  })
  // .addCase(addPopup, (state, { payload: { content, key, removeAfterMs = 15000 } }) => {
  //   state.popupList = (key ? state.popupList.filter((popup) => popup.key !== key) : state.popupList).concat([
  //     {
  //       key: key || nanoid(),
  //       show: true,
  //       content,
  //       removeAfterMs,
  //     },
  //   ])
  // })
  // .addCase(removePopup, (state, { payload: { key } }) => {
  //   state.popupList.forEach((p) => {
  //     if (p.key === key) {
  //       p.show = false
  //     }
  //   })
  // })
  // .addCase(setKashiApprovalPending, (state, action) => {
  //   state.kashiApprovalPending = action.payload
  // })
)
